$(document).ready(function() {
    $('.course-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
    });




    $('.news-image-gallery-container .orbit-bullets button a').on('click' , function (e) {
        window.location.href = $(this).attr('href');
    });

    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.course-gallery',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        prevArrow: false,
        nextArrow: false
    });

    $('.slick-slide').slickLightbox({
        itemSelector: '> div > a'
    });

    $('.add-more').on('click' , function(e){
        e.preventDefault();
        if ($('.active').last().next().data('id') === 5) {
            $(this).addClass('disabled');
        }
        $('.active').last().next().find('input').attr('required' , 'required');
        $('.active').last().next().addClass('active');



    });

    $('.minus').on('click' , function(e){
        e.preventDefault();
        var $id = $('.active').last().data('id');
        $('.student[data-id="'+$id+'"]').removeClass('active');
        $('.add-more').removeClass('disabled');
        $('.student[data-id="'+$id+'"]').find('input').removeAttr('required');
    });
    $('#teacher-form').on('submit' , function(e){
        e.preventDefault();
        var form = $(this);

        if ($(this).hasClass('popup-dismissed')) {


            $('.submit .fa-spin').show();
            $('.ajax-content').html('');
            var fnames = $(this).find('input[name="fname"]').map(function () {
                if ($(this).val() !== '') {
                    return $(this).val();
                }
            });
            var lnames = $(this).find('input[name="lname"]').map(function () {
                if ($(this).val() !== '') {
                    return $(this).val();
                }
            });

            var emails = $(this).find('input[name="email"]').map(function () {
                if ($(this).val() !== '') {
                    return $(this).val();
                }
            });

            var formValues = {
                'course_attending': $(this).find('select[name="course_attending"]').val(),
                'teacher': $(this).find('input[name="teacher"]').val(),
                'emails': emails.get(),
                'fnames': fnames.get(),
                'lnames': lnames.get(),
                'last_id': $('.active').last().data('id') - 1
            };

            var data = {
                'action': 'student_accounts',
                'data': formValues      // We pass php values differently!
            };
            // We can also pass the url value separately from ajaxurl for front end AJAX implementations
            jQuery.post(frontend_ajax_object.ajax_url, data, function (response) {
                console.log(response);
                $('.submit .fa-spin').hide();
                $('.ajax-content').html(response);
                $('#teacher-form').removeClass('popup-dismissed');
            });
        }
        else {
            var modal = $('#user_account');
            var course  = form.find('select[name="course_attending"]').val();

            modal.find('.content').html('<p>You have chosen to add students to the <strong>' + frontend_ajax_object.course_ids[course.split('_')[0]] + '</strong>.</p> <p class="text-center"><strong>Is this correct?</strong></p>');
            modal.foundation('open');
        }
    });
    $('.footer-buttons .yes').on('click' , function(){
        var modal = $('#user_account');
        modal.foundation('close');
        $('#teacher-form').addClass('popup-dismissed');
        $('#teacher-form').submit();
    });
});